export default __webpack_public_path__ + "static/media/utmc.ebc2aec6.png";